<template>
  <section class="evaluation_container">
    <article class="evaluation_title">{{ $t('来自用户真实的声音') }}</article>
    <section class="items" ref="itemContainer" :style="{ transform: `translateX(${translateX}px)` }">
      <EvaluationItem v-for="item in settingList" :key="item.company" v-bind="item" />
    </section>
  </section>
</template>

<script setup lang="ts">
import huaDaZhiZaoIcon from '@/assets/icons/huadazhizao.svg';
import miIcon from '@/assets/icons/mi.svg';
import shunFengIcon from '@/assets/icons/shunfeng.svg';
import tuYouIcon from '@/assets/icons/tuyou.svg';
import xiaoPengIcon from '@/assets/icons/xiaopeng.svg';
import chinaBankIcon from '@/assets/icons/china-bank.svg';
import EvaluationItem from './components/evaluation-item.vue';
import useTouchScroll from '@/composables/use-touch-scroll';
import { isMobile } from '~~/common/utils';

const settingList = [
  {
    icon: huaDaZhiZaoIcon,
    company: '华大智造',
    content: '“DG.hire让中国企业出海变得非常简单，5分钟完成服务下单，客户经理能够及时跟进反馈。”',
    avatar: 'https://video.reta-inc.com/image/default/B63969F6129A474BA34CFF9E5FA63D5A-6-2.jpg',
    job: '李志辉·HR',
  },
  {
    icon: miIcon,
    company: '小米集团',
    content: '“平台提供了标准的办事流程，支持在线查看项目办理进度，大大提高了协作效率。”',
    avatar: 'https://video.reta-inc.com/image/default/A581E197F3F6499982B2D254109750BF-6-2.jpg',
    job: '张先生·项目经理',
  },
  {
    icon: shunFengIcon,
    company: '顺丰速运',
    content: '“平台操作界面友好，有新手引导，降低了我们的使用成本，提供的服务超出了我们的诉求。”',
    avatar: 'https://video.reta-inc.com/image/default/7F5F4707E22A41E08F9AD912C71628FD-6-2.jpg',
    job: 'Lucy·HR',
  },
  {
    icon: tuYouIcon,
    company: '途游游戏',
    content: '“途游游戏在海外有900+员工，DG.hire能够通过标准化服务和先进的系统，帮助我们管理65%的员工。合作非常愉快。”',
    avatar: 'https://video.reta-inc.com/image/default/56C17479F48B4D54AA6823652AC9A073-6-2.jpg',
    job: '王女士·招聘经理',
  },
  {
    icon: xiaoPengIcon,
    company: '小鹏汽车',
    content: '“DG.hire在海外具有很强的落地能力，相比其他服务商，DG.hire总能在项目开始帮我预先规避法律风险”',
    avatar: 'https://video.reta-inc.com/image/default/472DE872038E41119DAE453FDB4F77A0-6-2.jpg',
    job: '许先生·法务',
  },
  {
    icon: chinaBankIcon,
    company: '中国银行',
    content: '“员工薪酬账单能够每个月在平台中查看跟进，保证了账实一致，同时历史数据可归档。”',
    avatar: 'https://video.reta-inc.com/image/default/0751026E16DE473EBF6A6AA0D821D403-6-2.jpg',
    job: '杨女士·项目总监',
  },
  {
    icon: huaDaZhiZaoIcon,
    company: '华大智造',
    content: '“DG.hire让中国企业出海变得非常简单，5分钟完成服务下单，客户经理能够及时跟进反馈。”',
    avatar: 'https://video.reta-inc.com/image/default/324FA959C52E483484C04105F5A1089A-6-2.png',
    job: '李志辉·HR',
  },
  {
    icon: miIcon,
    company: '小米集团',
    content: '“平台提供了标准的办事流程，支持在线查看项目办理进度，大大提高了协作效率。”',
    avatar: 'https://video.reta-inc.com/image/default/37F11FA42B094AC796A2425E5CCED246-6-2.png',
    job: '张先生·项目经理',
  },
  {
    icon: shunFengIcon,
    company: '顺丰速运',
    content: '“平台操作界面友好，有新手引导，降低了我们的使用成本，提供的服务超出了我们的诉求。”',
    avatar: 'https://video.reta-inc.com/image/default/C4EAEA3E4A00401EA5813BAEC188B888-6-2.png',
    job: 'Lucy·HR',
  },
  {
    icon: tuYouIcon,
    company: '途游游戏',
    content: '“途游游戏在海外有900+员工，DG.hire能够通过标准化服务和先进的系统，帮助我们管理65%的员工。合作非常愉快。”',
    avatar: 'https://video.reta-inc.com/image/default/747A84325F934C5E8906AEE59086904F-6-2.png',
    job: '王女士·招聘经理',
  },
  {
    icon: xiaoPengIcon,
    company: '小鹏汽车',
    content: '“DG.hire在海外具有很强的落地能力，相比国内其他竞品，DG.hire总能在项目开始帮我预先规避法律风险”',
    avatar: 'https://video.reta-inc.com/image/default/0E6A834121BB45DB8DF62A325AB9F212-6-2.png',
    job: '许先生·法务',
  },
];
const itemContainer = ref<HTMLDivElement>();
const resetWidth = ref(0);
const mobile = isMobile();
let translateX = ref(0);
let stopAutoSwitch = ref(false);

function init() {
  if (mobile) {
    const { translateX: tx, stopAutoSwitch: sas } = useTouchScroll(itemContainer, resetWidth);
    translateX = tx;
    stopAutoSwitch = sas;
  } else {
    // const { translateX: tx, stopAutoSwitch: sas } = useMouseScroll(
    //   itemContainer,
    //   resetWidth
    // );
    // translateX = tx;
    // stopAutoSwitch = sas;
  }
}
init();

function autoAnimation() {
  if (!stopAutoSwitch.value) {
    translateX.value -= 0.5;
    if (translateX.value <= resetWidth.value) {
      translateX.value = 0;
    }
  }
  requestAnimationFrame(autoAnimation);
}

onMounted(() => {
  const width = (itemContainer.value?.children[0] as HTMLElement)?.clientWidth;
  width && (resetWidth.value = -(width + 24) * 6);
  autoAnimation();
});
</script>
<style lang="less" scoped>
@media screen and (min-width: 800px) {
  // @keyframes auto-scroll {
  //   0% {
  //     transform: translateX(0);
  //   }
  //   100% {
  //     // transform: translateX(v-bind(resetWidth));
  //   }
  // }
  .evaluation_container {
    padding: 80px 0 120px;
    position: relative;
    width: 100%;
    overflow-x: hidden;

    .evaluation_title {
      font-weight: 600;
      font-size: 40px;
      line-height: 64px;
      text-align: center;
      letter-spacing: 0.5px;
      color: #202431;
    }

    .evaluation_title::after {
      content: 'Customer evaluation';
      display: block;
      font-weight: 600;
      font-size: 26px;
      line-height: 35px;
      text-align: center;
      color: #c9cdd4;
      margin-top: 5px;
    }

    .items {
      user-select: none;
      padding-top: 53px;
      display: flex;
      gap: 24px;
      // animation: auto-scroll linear 50s infinite;
    }
  }

  .items:hover {
    animation-play-state: paused;
  }
}
</style>
<style lang="less" scoped>
@media screen and(max-width:800px) {
  .evaluation_container {
    padding: 48px 0 45px;
    width: 100%;
    overflow-x: hidden;

    .evaluation_title {
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
      text-align: center;
      color: #202431;
    }

    .evaluation_title::after {
      content: 'Customer evaluation';
      display: block;
      font-weight: 600;
      font-size: 12px;
      line-height: 22px;
      text-align: center;
      color: #c9cdd4;
    }

    .items {
      padding-top: 24px;
      display: flex;
      gap: 24px;
      // transition: transform linear;
    }

    // .items:active {
    //   animation-play-state: paused;
    // }
  }
}
</style>
